import { useAtom } from 'jotai';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { alarmExclamationIconSvg } from '../assets/images';
import { notificationAtom } from '../jotai-atoms/notification.atom';
import { reservationDataAtom } from '../jotai-atoms/reservation-data.atom';
import { NotificationService } from '../services/notification';
import { Modal, ModalProps } from './Modal';

export interface ModalLiveClassMissedProps {
  show: boolean;
  onClose: () => void;
}

export const ModalLiveClassMissed: React.FC<ModalLiveClassMissedProps> = ({ show, onClose }) => {
  const __ = useTranslation().t;
  const [notification, setNotification] = useAtom(notificationAtom);
  const [reservationData, setReservationData] = useAtom(reservationDataAtom);

  const modalProps: ModalProps = {
    show,
    onClose,
    type: 'default',
    title: __('teacherIsWaiting'),
    submitButtonText: __('continue'),
  };

  const onSubmit = () => {
    if (!notification) {
      return;
    }
    NotificationService.putNotificationRead(notification.data.notificationId);
    setNotification(null);
    setReservationData({
      ...reservationData,
      forceRefreshUserData: !reservationData?.forceRefreshUserData,
    });
    onClose();
  };

  return (
    <StyledModal {...modalProps} onSubmit={onSubmit} onClose={onSubmit}>
      <Container>
        <StyledImg src={alarmExclamationIconSvg} alt="Alarm" />
        <div>{__('lateForClassNotAbleToJoinLater')}</div>
      </Container>
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  max-width: 560px;
`;

const StyledImg = styled.img`
  margin-right: 16px;
`;

const Container = styled.div`
  display: flex;
  align-items: start;
  font-family: 'Inter';
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.dark};
  padding-bottom: 8px;
`;
